import styled from "styled-components";

export const HomeStyle = styled.div`
  .heading-icon {
    color: #f28809;
  }
`;
